import axios from "axios";
import { authHeader, removeDiskCache, handleResponse } from "../_helpers";
import EnvironmentUtil from "../_utils/EnvironmentUtil";

export const userService = {
  login,
  logout,
};

const apiClient = axios.create({
  /**
   * Import the config from the App/Config/index.js file
   */
  baseURL: EnvironmentUtil.getEnvObject().url,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 12000,
});

function login(username, password) {
  // apiClient.defaults.headers.post["mobile-version"] = -1;
  return apiClient
    .post(`/auth/login`, { email: username, password })
    .then(handleResponse)
    .then((response) => {
      localStorage.setItem("OLRToolsUser", JSON.stringify(response));
      return response;
    })
    .catch((error) => {
      throw error;
    });
}

function logout() {
  // call api to logout session
  //

  // remove user from local storage to log user out
  localStorage.removeItem("OLRToolsUser");
}
